import get from 'transmute/get';
export const getFile = get('file');
export const getLocalId = get('localId');
export const getFileId = get('fileId');
export const getUploadProgress = get('uploadProgress');